package com.mps.asc_app.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.unit.dp
import com.mps.asc_app.presentation.MainViewModel
import com.mps.asc_app.ui.components.AppTextField

@Composable
fun ForgotPasswordScreen(
    mainViewModel: MainViewModel,
    onBackToLogin: () -> Unit,
    contentPadding: PaddingValues = PaddingValues(0.dp),
) {
    val uiState by mainViewModel.uiState.collectAsState()

    ForgotPasswordScreenContent(
        isSending = uiState.isSendingPasswordResetEmail,
        success = uiState.passwordResetSuccess,
        error = uiState.passwordResetError,
        onSendResetEmail = mainViewModel::requestPasswordReset,
        onBackToLogin = {
            mainViewModel.clearPasswordResetFeedback()
            onBackToLogin()
        },
        onEmailChanged = { mainViewModel.clearPasswordResetFeedback() },
        contentPadding = contentPadding,
    )
}

@Composable
fun ForgotPasswordScreenContent(
    isSending: Boolean,
    success: Boolean,
    error: String?,
    onSendResetEmail: (String) -> Unit,
    onBackToLogin: () -> Unit,
    onEmailChanged: () -> Unit,
    contentPadding: PaddingValues = PaddingValues(0.dp),
) {
    var email by rememberSaveable { mutableStateOf("") }

    Column(
        modifier = Modifier
            .padding(contentPadding)
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.background)
            .padding(horizontal = 16.dp, vertical = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(max = 460.dp),
            shape = MaterialTheme.shapes.extraLarge,
            color = MaterialTheme.colorScheme.surface,
            tonalElevation = 2.dp,
            shadowElevation = 4.dp,
        ) {
            Column(
                modifier = Modifier.padding(20.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Text(
                    text = "Passwort vergessen",
                    style = MaterialTheme.typography.headlineSmall,
                    color = MaterialTheme.colorScheme.onSurface,
                )
                Text(
                    text = "Gib deine E-Mail-Adresse ein. Du bekommst dann einen Link zum Zurücksetzen.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )

                AppTextField(
                    value = email,
                    onValueChange = {
                        email = it
                        onEmailChanged()
                    },
                    label = "E-Mail Adresse",
                    modifier = Modifier.fillMaxWidth(),
                    imeAction = ImeAction.Done,
                    onImeAction = { onSendResetEmail(email) }
                )

                if (success) {
                    Surface(
                        color = MaterialTheme.colorScheme.primaryContainer,
                        contentColor = MaterialTheme.colorScheme.onPrimaryContainer,
                        shape = MaterialTheme.shapes.medium,
                    ) {
                        Text(
                            text = "E-Mail wurde gesendet.",
                            style = MaterialTheme.typography.bodySmall,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 12.dp, vertical = 10.dp),
                        )
                    }
                }

                if (!error.isNullOrBlank()) {
                    Surface(
                        color = MaterialTheme.colorScheme.errorContainer,
                        contentColor = MaterialTheme.colorScheme.onErrorContainer,
                        shape = MaterialTheme.shapes.medium,
                    ) {
                        Text(
                            text = error,
                            style = MaterialTheme.typography.bodySmall,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 12.dp, vertical = 10.dp),
                        )
                    }
                }

                Spacer(Modifier.height(4.dp))

                Button(
                    onClick = { onSendResetEmail(email) },
                    modifier = Modifier.fillMaxWidth(),
                    enabled = !isSending,
                ) {
                    Text("Reset-Link senden")
                }

                OutlinedButton(
                    onClick = onBackToLogin,
                    modifier = Modifier.fillMaxWidth(),
                    enabled = !isSending,
                ) {
                    Text("Zurück zum Login")
                }
            }
        }
    }
}
